import i18nFactory from '@yandex-int/i18n';
import classNames from 'classnames';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { HelpLink } from '../../typings/doc-center';
import { ButtonDecorator } from '../ButtonDecorator/ButtonDecorator';
import { ErrorItem, ErrorsPresenter } from '../ErrorsPresenter/ErrorsPresenter';
import { ErrorsView } from '../ErrorsView/ErrorsView';
import { HoverTooltipWrapper } from '../HoverTooltipWrapper/HoverTooltipWrapper';
import { Shape2, Shape2Icon, Shape2Theme, Shape2Tone } from '../Shape2/Shape2';

import './BulkChangeDecorator.css';
import * as keyset from './BulkChangeDecorator.i18n';

const i18n = i18nFactory(keyset);
const BLOCK = 'bulk-change-decorator';

export interface BulkChangeDecoratorProps {
    title: string;
    adsDescription: string;
    isInProgress: boolean;
    isAcceptButtonDisabled?: boolean;
    onAcceptClick: () => void;
    onCancelClick: () => void;
    errors?: ErrorItem[];
    buttonAcceptText: string;
    children: React.ReactNode;
    renderButtonContainer?: () => React.ReactNode;
    textInfo?: React.ReactNode;
    cls?: string;
    infoTootipText?: string;
    infoTootipHeader?: string;
    infoTootipMoreLink?: HelpLink;
    onTootipMoreLinkClick?: (link: HelpLink) => void;
}

export class BulkChangeDecorator extends React.Component<
    BulkChangeDecoratorProps
> {
    render() {
        const {
            errors = [],
            children,
            renderButtonContainer,
            cls
        } = this.props;

        return (
            <div className={classNames(Bem.cls(BLOCK), cls)}>
                <ErrorsPresenter errors={errors}>
                    {this.renderTitle()}
                    {this.renderAdsDescription()}
                    {renderButtonContainer && renderButtonContainer()}
                    {this.renderTextInfo()}
                    {children}
                    {this.renderError()}
                    {this.renderButtonContainer()}
                </ErrorsPresenter>
            </div>
        );
    }

    private renderTitle = () => (
        <div className={Bem.cls(BLOCK, 'title')}>{this.props.title}</div>
    );

    private renderAdsDescription = () => (
        <div className={Bem.cls(BLOCK, 'ads-description')}>
            {this.props.adsDescription}
        </div>
    );

    private renderTextInfo = () => {
        const {
            textInfo,
            infoTootipText,
            infoTootipHeader,
            infoTootipMoreLink,
            onTootipMoreLinkClick
        } = this.props;

        if (textInfo === undefined) {
            return null;
        }

        return (
            <div className={Bem.cls(BLOCK, 'info')}>
                {textInfo}
                {infoTootipText !== undefined ? (
                    <HoverTooltipWrapper
                        to={['right']}
                        header={infoTootipHeader}
                        tooltipText={infoTootipText}
                        moreLink={infoTootipMoreLink}
                        onMoreLinkClick={onTootipMoreLinkClick}
                    >
                        <Shape2
                            icon={Shape2Icon.help}
                            theme={Shape2Theme.default}
                            tone={Shape2Tone.darkGrey}
                            width={12}
                            height={12}
                            cls={Bem.cls(BLOCK, 'icon-info')}
                        />
                    </HoverTooltipWrapper>
                ) : null}
            </div>
        );
    };

    private renderError = () => {
        const { errors = [] } = this.props;

        if (errors.length === 0) {
            return null;
        }

        return (
            <div className={Bem.cls(BLOCK, 'error-container')}>
                <ErrorsView path={''} />
            </div>
        );
    };

    private renderButtonContainer = () => {
        const {
            buttonAcceptText,
            isAcceptButtonDisabled = false,
            onAcceptClick,
            isInProgress,
            onCancelClick
        } = this.props;

        return (
            <div className={Bem.cls(BLOCK, 'button-container')}>
                <ButtonDecorator
                    theme={'action'}
                    text={buttonAcceptText}
                    size={'n'}
                    tone="default"
                    view="classic"
                    disabled={isAcceptButtonDisabled}
                    onClick={onAcceptClick}
                    progress={isInProgress}
                />

                <ButtonDecorator
                    theme={'normal'}
                    text={i18n('button-cancel')}
                    size={'n'}
                    cls={Bem.cls(BLOCK, 'button-cancel')}
                    onClick={onCancelClick}
                    disabled={isInProgress}
                />
            </div>
        );
    };
}
